import {Box, HStack} from '@chakra-ui/react';
import {useDesktop} from 'hooks';
import {FC} from 'react';
import {hiddenScrollBarStyles} from 'theme';
import {IPromoCategoryResponse} from 'types';

import {Slider} from '../slider';
import {PromotionTile} from './components/promotion-tile';

interface Props {
  promotions?: IPromoCategoryResponse[];
  isMarkets?: boolean;
}

export const PromotionList: FC<Props> = ({promotions, isMarkets}) => {
  const isDesktop = useDesktop();
  if (!promotions?.length) return null;

  return (
    <Box ml={['13px', '35px']}>
      {promotions.length > 8 ? (
        <Slider slidesToShow={isDesktop ? 4.3 : 1.3} slidesToScroll={isDesktop ? 4 : 1} infinite={false} speed={500}>
          {promotions.map((item, index) => {
            return (
              <Box key={index} mx="15px">
                <PromotionTile promotion={item} isMarkets={isMarkets} />
              </Box>
            );
          })}
        </Slider>
      ) : (
        <HStack
          alignItems="flex-start"
          spacing={isDesktop ? '30px' : '15px'}
          overflow="scroll"
          sx={hiddenScrollBarStyles}
        >
          {promotions.map((item) => {
            return <PromotionTile key={item.name} promotion={item} isMarkets={isMarkets} />;
          })}
        </HStack>
      )}
    </Box>
  );
};
